import React, { Component } from 'react';
import moment from 'moment';
import { Panel } from 'react-bootstrap';


export default class TablaPendientes extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selected: [],
        rowSelected:[],
        showFilter: false,
        showModeTarget:'none',
        checkCodPlanEntrVehi:'',
        checkRowsPerdido:{},
      }
    }

    functionDespliegue = (index) => {
      const isExpanded = index === this.state.rowSelected;
      return isExpanded;
    }
  
    toggleRow = (index) =>{
      if (index === this.state.rowSelected) {
        this.setState({ rowSelected: '' });
      } else {
        this.setState({ rowSelected: index });
      }
    }

    render(){
        return(
            <section>
                <div className='tableWrapper'>
                <div className='hidden-xs'>
                    <table className='table table-hover' >
                        <thead className='table-head'>
                            <tr>
                            <th>
                                {/* <div className='checkbox checkbox-inline'>
                                <label>
                                    <input type='checkbox' id={'checkBoxAll'} onClick={() => this.selectFDEntregaAll()} />
                                    <div className='checkbox-skin' />
                                </label>
                                </div> */}
                            </th>
                            <th>CLIENTE</th>
                            <th>N° DE PEDIDO</th>
                            <th>N° CHASIS</th>
                            <th>MARCA</th>
                            <th>MODELO</th>
                            <th>N° FICHA VENTA</th>
                            <th>F° COMP. LOGÍSTICO</th>
                            <th>F° COMP. COMERCIAL</th>
                            <th>F° RECEPCIÓN DE PLACAS</th>
                            <th />
                            </tr>
                        </thead>
                        {
                            this.props.fichasEntrega.map((Rows,i)=>(
                                <tbody>
                                    <tr key={i}>
                                        <td>
                                            {/* <div className='checkbox checkbox-inline'>
                                            <label>
                                                <input type='checkbox' checked={this.state.selectedID.includes(Rows.numPedidoVeh, Rows)} />
                                                <div className='checkbox-skin' onClick={() => this.handleOnClickProgramerAll(Rows.numPedidoVeh, Rows)} />
                                            </label>
                                            </div> */}
                                        </td>
                                        <td>{Rows.desCliente}</td>
                                        <td>{Rows.numPedidoVeh}</td>
                                        <td>{Rows.numChasis}</td>
                                        <td>{Rows.nomMarca}</td>
                                        <td>{Rows.modelo}</td>
                                        <td>{Rows.numFichaVta}</td>
                                        <td>{Rows.fechaComLog ? moment(Rows.fechaComLog).format('DD/MM/YY') : '-' }</td>
                                        <td>{Rows.fechaCompEntrega ? moment(Rows.fechaCompEntrega).format('DD/MM/YY') : '-' }</td>
                                        <td>{Rows.fecRecepPlaca ? moment(Rows.fecRecepPlaca).format('DD/MM/YY') : '-' }</td>
                                        <td onClick={() => this.toggleRow(i)} className='ion-chevron-down ml-3 c-cyan  open'  />

                                    </tr>
                                    <tr className='table-extra'>
                                      <td colSpan='13'>
                                        <Panel collapsible expanded={this.functionDespliegue(i)} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }}>
                                          <div className='collapse in'>
                                            <div className='table-extra-wrap'>
                                              <ul className='row'>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Filial de venta</p>
                                                  <p>{Rows.filialVenta}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Tipo operación</p>
                                                  <p>{Rows.tipoFinanciamiento}</p>
                                                </li>
                                                <li className='col-md-2'>
                                                  <p className='labelInfo'>Fecha de asignacion</p>
                                                  <p>{Rows.fechaAsignacion}</p>
                                                </li>
                                                <li className='col-md-2'>
                                              <p className='labelInfo'>Tipo liberación</p>
                                              <p>{Rows.tipoLiberacion}</p>
                                            </li>  
                                            <li className='col-md-2'>
                                              <p className='labelInfo'>Fecha liberación</p>
                                              <p>{Rows.fechaliberacion}</p>
                                            </li>
                                            <li className='col-md-2'>
                                              <p className='labelInfo'>Estado cancelación</p>
                                              <p>{Rows.desEstadoCancelacionPed}</p>
                                            </li>
                                            <li className='col-md-2'>
                                              <p className='labelInfo'>Estado pedido</p>
                                              <p>{Rows.estadoPedido}</p>
                                            </li>
                                            <li className='col-md-2'>
                                                    <p className='labelInfo'>Filial actual</p>
                                                    <p>{Rows.descNomFilial}</p>
                                            </li>
                                            <li className='col-md-2'>
                                                    <p className='labelInfo'>Ubicación actual</p>
                                                    <p>{Rows.desubicapedido}</p>
                                            </li>
                                                     
                                                </ul>                                  
                                                </div>
                                            </div>
                                        </Panel>
                                        </td>
                                    </tr>
                                </tbody>
                            ))
                        }
                    </table>
                </div>
                </div>
                <div className='visible-xs'>

                     
          {this.props.fichasEntrega.map((Rows, i) => (
                  
            <div className="tableMob">
                <div className="tableMob-mainContent">
                  <div className="tableMob-header">
                    {/* <div className="tableMob-check">
                      <div className="checkbox">
                        <label>
                          <input type='checkbox' checked={this.props.selectedID.includes(Rows.codPlanEntrVehi, Rows)} />
                          <div className='checkbox-skin' onClick={() => {this.props.handleOnClickProgramerAll(Rows.codPlanEntrVehi, Rows);this.activeTarget(Rows.codPlanEntrVehi,Rows)}} />
                        </label>
                      </div>
                    </div> */}
                    <h3 className="tableMob-title">{Rows.desCliente}</h3>
                  </div>
                  <ul className="tableMob-content row">
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">N° de Pedido</p>
                      <p>{Rows.numPedidoVeh}</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">N° de Chasis</p>
                      <p>{Rows.numChasis}</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">Marca</p>
                      <p>{Rows.nomMarca}</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">Modelo</p>
                      <p>{Rows.modelo}</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">N° Ficha venta</p>
                      <p>{Rows.numFichaVta}</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">F° comp. logístico</p>
                      <p>{Rows.fechaComLog ? moment(Rows.fechaComLog).format('DD/MM/YY') : '-' }</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">F° comp. comercial</p>
                      <p>{Rows.fechaCompEntrega ? moment(Rows.fechaCompEntrega).format('DD/MM/YY') : '-' }</p>
                    </li>
                    <li className="tableMob-content-item col-xs-6">
                      <p className="labelInfo">F° recepción de placas</p>
                      <p>{Rows.fecRecepPlaca ? moment(Rows.fecRecepPlaca).format('DD/MM/YY') : '-' }</p>
                    </li>
                    
                    <li className="tableMob-content-item col-xs-6">
                                <p className="labelInfo">Filial de venta</p>
                                <p>{Rows.filialVenta}</p>
                                </li>

                                <li className="tableMob-content-item col-xs-6">
                                <p className="labelInfo">Tipo operación</p>
                                <p>{Rows.tipoFinanciamiento}</p>
                                </li>

                                <li className="tableMob-content-item col-xs-6">
                                <p className="labelInfo">Fecha de asignacion</p>
                                <p>{Rows.fechaAsignacion}</p>
                                </li>
                                <li className='tableMob-content-item col-xs-6'>
                                  <p className='labelInfo'>Tipo liberación</p>
                                  <p>{Rows.tipoLiberacion}</p>
                                </li>  
                                <li className='tableMob-content-item col-xs-6'>
                                  <p className='labelInfo'>Fecha liberación</p>
                                  <p>{Rows.fechaliberacion}</p>
                                </li> 
                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Estado cancelación</p>
                                    <p>{Rows.desEstadoCancelacionPed}</p>
                                </li>

                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Estado pedido</p>
                                    <p>{Rows.estadoPedido}</p>
                                </li>   
                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Filial actual</p>
                                    <p>{Rows.descNomFilial}</p>
                                </li>
                                <li className='tableMob-content-item col-xs-6'>
                                    <p className='labelInfo'>Ubicación actual</p>
                                    <p>{Rows.desubicapedido}</p>
                                </li>               
                  </ul>                  
                </div>
                <div className="tableMob-extraContent collapse">
                </div>
              </div>
          ))  
          } 
          </div>

            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/tablasEntregas/pendientes.js